'use client'

import { useState, useEffect } from 'react'
import { getCurrentTeilnehmer } from '@/actions/checkAuth'

export function useAuth() {
  const [user, setUser] = useState<any>(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [loading, setLoading] = useState(true)

  const checkAuth = async () => {
    setLoading(true)
    const result = await getCurrentTeilnehmer()
    setUser(result.user)
    setIsLoggedIn(result.isLoggedIn)
    setLoading(false)
  }

  useEffect(() => {
    checkAuth()
  }, [])

  // Return the checkAuth function so components can call it manually
  return { user, isLoggedIn, loading, refreshAuth: checkAuth }
}
